'use client';
import { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

import { searchParamsToQuery } from '@utils/searchParamsToQuery';

/**
 * Convert URLSearchParams to query object
 * @returns object
 */
export const useSearchParamsToQuery = <
  T extends { [key: string]: string | string[] } = {
    [key: string]: string | string[];
  }
>() => {
  const searchParams = useSearchParams();

  const query = useMemo(() => {
    return searchParams ? (searchParamsToQuery(searchParams) as T) : ({} as T);
  }, [searchParams]);

  return query;
};
